/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many pounds are in a kilogram?`)
};

const es_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántas libras hay en un kilogramo?`)
};

const de_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Pfund hat ein Kilogramm?`)
};

const nl_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel pond zitten in een kilogram?`)
};

const fr_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de livres sont dans un kilogramme ?`)
};

const it_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quante libbre ci sono in un chilogrammo?`)
};

const pt_br2_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas libras tem em um quilograma?`)
};

const pt_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas libras existem num quilograma?`)
};

const ja_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1キログラムには何ポンドありますか?`)
};

const zh_uc_wt_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_wt_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_wt_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_wt_faq1_q", locale)
	if (locale === "en") return en_uc_wt_faq1_q(inputs)
	if (locale === "es") return es_uc_wt_faq1_q(inputs)
	if (locale === "de") return de_uc_wt_faq1_q(inputs)
	if (locale === "nl") return nl_uc_wt_faq1_q(inputs)
	if (locale === "fr") return fr_uc_wt_faq1_q(inputs)
	if (locale === "it") return it_uc_wt_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_wt_faq1_q(inputs)
	if (locale === "pt") return pt_uc_wt_faq1_q(inputs)
	if (locale === "ja") return ja_uc_wt_faq1_q(inputs)
	return zh_uc_wt_faq1_q(inputs)
};